<template>
	<div class="bg">
		<el-tabs v-model="activeName">
			<el-tab-pane label="新户自动化上线" name="first">
				<adsOnlineAutoList></adsOnlineAutoList>
			</el-tab-pane>
			<el-tab-pane label="(旧)新户自动化上线" name="second"
				><newUserOnline></newUserOnline
			></el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import adsOnlineAutoList from '@/backend/pages/googleAds/adsOnlineAutoList.vue';
import newUserOnline from '@/backend/pages/googleAds/newUserOnline.vue';
export default {
	data() {
		return {
			activeName: 'first',
		};
	},

	components: { adsOnlineAutoList, newUserOnline },

	computed: {},

	methods: {},
};
</script>

<style lang="scss" scoped>
.bg {
	// padding: 20px;
	::v-deep .el-tabs__header {
		background: #ffffff;
		margin: 0px;
		padding: 20px;
	}
}
</style>
